<template>
    <div class="recognize-list">
        <div class="search-top">
            <el-input placeholder="请输入搜索内容" v-model="searchKeyword" class="search-input"> 
                <el-button type="primary" slot="append"  @click="getSearch" >方剂识别</el-button>  
            </el-input> 
            <!-- <el-input 
                placeholder="请输入内容"
                v-model.trim="keyword" 
            />
            <div class="textarea-btn">
                <el-button type="primary" @click='getSearch'>方剂识别</el-button> 
            </div> -->
        </div> 
        <!-- 包含方剂 -->
        <jdFj ref='jdFj_ref' :keyword='keyword' @toDetails='toDetails'></jdFj>
        <!-- 相似方剂 -->
        <allFj ref='allFj_ref' :keyword='keyword'  @toDetails='toDetails'></allFj>
    </div>
</template>

<script>
import jdFj from './comps/jd_fj.vue'
import allFj from './comps/all_fj.vue' 
export default {
    props: ['keyword'],
    components: {
        jdFj,
        allFj,
    },
    data () {
        return {
            
        }
    },
    computed: {
        searchKeyword: {
            get() {
                return this.keyword;
            },
            set(val) {
                this.$emit('update:keyword', val);
            },
        },
    },
    mounted () { 
        this.getSearch()
    },
    methods: {
        getSearch(){ 
            this.$refs.jdFj_ref.getList(1)
            this.$refs.allFj_ref.getList(1);
        }, 
        clear(){
            this.$emit('update:keyword', '');
        },
        toDetails(row){
            let url= this.$router.resolve({
                path:'recognizeFjDetails',
                query:{
                    id:row.id, 
                    keyWord:row.title,
                }
            }) 
            this.$windowOpen({ url:url.href,isLogin:true} )
        },
        
    }
}
</script>
<style lang="less" scoped>
.recognize-list{
    .search-top{
        display:flex;
        .search-input{
            width: 100%;  
        }
        ::v-deep .el-input-group__append{
            background: #386DE8;
            color: #fff;
            border: 1px solid #386DE8; 
        }
    }
    .tips{
        line-height: 30px;
        color: #555;
        padding: 10px 0;
        span{
            color: red;
            font-weight: bold;
        }
    }
    .table-title{ 
        line-height: 24px; 
        color: #606266;
        font-weight: normal;
        max-height: 48px;
        padding:0; 
        // cursor: pointer;
        &:hover{
            color:#97623c;
            text-decoration: none;
        }
        .tit-tips{
            display: inline-block;
            font-weight: bold;
            color: red;
            font-size: 20px;
            height: 24px;
        }
    }
}
.page-wrap{
    margin-top: 10px;
}
</style>